import React, { useEffect, useState } from 'react';
import { db } from '../../firebase';
import { addDoc, collection, Timestamp } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import './css/ProgramarCorreo.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faList } from '@fortawesome/free-solid-svg-icons';
import { mostrarError, mostrarExito, mostrarInfo } from '../../utils/Alertas';
import { TextField } from '@mui/material';

const ProgramarCorreo: React.FC = () => {
    // Obtiene la fecha actual + 1 minuto para mostrar en el formulario
    const getDefaultDateTime = () => {
        const now = new Date();
        now.setMinutes(now.getMinutes() + 1);
        now.setSeconds(0);
        now.setMilliseconds(0);
        now.setMinutes(now.getMinutes() - now.getTimezoneOffset());
        return now.toISOString().slice(0, 16);
    };

    const [to, setTo] = useState('');
    const [subject, setSubject] = useState('');
    const [message, setMessage] = useState('');
    const [scheduledAt, setScheduledAt] = useState(getDefaultDateTime());
    const [isLoggedIn, setIsLoggedIn] = useState(false);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();

        const user = getAuth().currentUser;
        if (!user || !user.email) {
            mostrarInfo(<>Debes <a href="/?login=1" className="login-link">iniciar sesión</a> para programar un correo.</>);
            return;
        }

        if (!to.trim() || !subject.trim() || !message.trim() || !scheduledAt) {
            mostrarInfo('Por favor, completa todos los campos antes de continuar');
            return;
        }

        try {
            await addDoc(collection(db, 'emailsProgramados'), {
                to,
                subject,
                message,
                scheduledAt: Timestamp.fromDate(new Date(scheduledAt)),
                remitente: user.email,
                uid: user.uid,
                estado: 'Pendiente',
                creadoEn: Timestamp.now(),
            });

            mostrarExito('Correo programado correctamente.');
            setTo('');
            setSubject('');
            setMessage('');
            setScheduledAt(getDefaultDateTime());
        } catch (error) {
            console.error('Error al programar el correo:', error);
            mostrarError('Error al programar el correo. Inténtalo más tarde.');
        }
    };

    useEffect(() => {
        const unsubscribe = getAuth().onAuthStateChanged(user => {
            setIsLoggedIn(!!user);
        });
        return () => unsubscribe();
    }, []);

    return (
        <div className="container-fluid" style={{ paddingRight: 0, paddingLeft: 0, paddingBottom: 0 }}>
            <form onSubmit={handleSubmit} className="form-correo">
                <h2>Programar un correo</h2>
                <TextField
                    type="email"
                    label="Destinatario"
                    variant="outlined"
                    value={to}
                    onChange={(e) => setTo(e.target.value)}
                    fullWidth
                    margin="normal"
                />

                <TextField
                    type="text"
                    label="Asunto"
                    variant="outlined"
                    value={subject}
                    onChange={(e) => setSubject(e.target.value)}
                    fullWidth
                    margin="normal"
                />

                <TextField
                    label="Mensaje"
                    variant="outlined"
                    multiline
                    rows={6}
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    fullWidth
                    margin="normal"
                />

                <TextField
                    type="datetime-local"
                    label="Fecha y hora"
                    InputLabelProps={{ shrink: true }}
                    variant="outlined"
                    value={scheduledAt}
                    onChange={(e) => setScheduledAt(e.target.value)}
                    fullWidth
                    margin="normal"
                />
                <button className="main-button" type="submit">Programar correo</button>
            </form>
            {isLoggedIn && (
                <button
                    className="fab-boton"
                    onClick={() => window.location.href = '/mis-correos'}
                    title="Ver mis correos"
                >
                    <FontAwesomeIcon icon={faList} />
                </button>
            )}
        </div>
    );
};

export default ProgramarCorreo;
